<div
	class="relative min-h-[300px] w-[90vw] bg-auto rounded-t-[40px] rounded-b-[15px] bg-center mx-auto overflow-hidden shadow-[0px_10px_15px_2px_#00000010]"
>
	<a
		class="min-h-[300px] w-[90vw] absolute"
		[href]="
			mainService.getOfferUrl(offer()) +
			'?' +
			mainService.getUrlParams(offer(), 'url', offersFacade.selected$ | async)
		"
		(click)="mainService.handleButtonClick($event, offer())"
	>
	</a>
	@let imgWidth = 500;
	@if (offer().multimedia?.length > 0 && !!offer().multimedia[0]?.multimedia.url) {
		<img
			class="h-[300px]"
			height="300"
			[width]="imgWidth"
			[ngSrc]="offer().multimedia[0]?.multimedia.url | optimizedImage: { width: imgWidth }"
			[alt]="offer().product.name"
			loading="lazy"
		/>
	} @else {
		<p>Brak zdjęcia</p>
	}
	@let promotionImgWidth = 500;
	@if (!!offer().promotion?.catalog.multimedia) {
		<img
			[ngSrc]="offer().promotion?.catalog.multimedia | optimizedImage: { width: promotionImgWidth }"
			alt="Promocja"
			height="300"
			[width]="promotionImgWidth"
			class="absolute top-7 w-1/3"
		/>
	}

	<div
		class="bg-white px-4 py-2 bg-opacity-70 bottom-0 left-0 w-full text-sm flex justify-center flex-col text-mainColor"
	>
		<h1 class="text-left w-9/10 font-extrabold truncate md:whitespace-normal md:overflow-visible">
			{{ offer().product.name }}
		</h1>
		<div class="flex flex-col justify-between w-full">
			<p class="font-medium">
				{{ offer().stop.departureDatetime | polishDate }} - {{ offer().stop.returnDatetime | polishDate }}
			</p>
			<p class="text-mainColor font-extrabold text-xl text-right">
				od
				<span class="text-accentColor">{{ offer().fullPrice | price }}</span>
			</p>
		</div>
	</div>
	<div class="absolute top-0 right-0 p-4 hidden">
		<i class="fa-regular fa-heart text-red text-2xl"></i>
	</div>
</div>
